// Internal Chat command contract (SPEC-2026-07-internal-chat, T-16).
// Manual mirror of trendmulti-apps/libs/trendmulti-entity/src/microservices/
// chat.inbound.ts — values MUST stay byte-identical to the backend contract.
// The client emits `chat:command` WITHOUT identity fields: userId/companyId/
// companyCode/roles are stamped server-side by the websocket gateway from the
// socket's verified JWT — client-supplied identity is never trusted.

export enum ChatCommandTypeEnum {
  MESSAGE_SEND = 'MESSAGE_SEND',
  MESSAGE_EDIT = 'MESSAGE_EDIT',
  MESSAGE_DELETE = 'MESSAGE_DELETE',
  THREAD_REPLY = 'THREAD_REPLY',
  REACTION_TOGGLE = 'REACTION_TOGGLE',
  FORWARD = 'FORWARD',
  SAVED_TOGGLE = 'SAVED_TOGGLE',
  READ = 'READ',
  MARK_UNREAD = 'MARK_UNREAD',
  CHANNEL_CREATE = 'CHANNEL_CREATE',
  CHANNEL_JOIN = 'CHANNEL_JOIN',
  CHANNEL_LEAVE = 'CHANNEL_LEAVE',
  CHANNEL_INVITE = 'CHANNEL_INVITE',
  CHANNEL_ARCHIVE = 'CHANNEL_ARCHIVE',
  CHANNEL_DELETE = 'CHANNEL_DELETE',
  CHANNEL_PIN_MESSAGE = 'CHANNEL_PIN_MESSAGE',
  CHANNEL_UNPIN_MESSAGE = 'CHANNEL_UNPIN_MESSAGE',
  FAVORITE_SECTION_UPSERT = 'FAVORITE_SECTION_UPSERT',
  FAVORITE_SECTION_DELETE = 'FAVORITE_SECTION_DELETE',
  FAVORITE_TOGGLE = 'FAVORITE_TOGGLE',
  NOTIFICATION_SET_LEVEL = 'NOTIFICATION_SET_LEVEL',
  STATUS_SET = 'STATUS_SET',
  STATUS_CLEAR = 'STATUS_CLEAR',
  SETTINGS_UPDATE = 'SETTINGS_UPDATE',
  PRESENCE_CONNECTED = 'PRESENCE_CONNECTED',
  PRESENCE_DISCONNECTED = 'PRESENCE_DISCONNECTED',
}

/**
 * Client-side `chat:command` envelope — ChatCommandInbound MINUS the identity
 * fields the gateway stamps from the verified JWT. `requestId` correlates the
 * command with the `chat:ack` emitted back to the sender's personal room.
 */
export interface ChatCommandOutbound {
  type: ChatCommandTypeEnum;
  requestId: string;
  sentAt: string;
  payload: Record<string, unknown>;
}
